export const REQUEST_LEAVE_LAYOUT = {
  dialogActionMinWidth: 100,
  statusBackgroundOpacity: {
    dark: 0.24,
    light: 0.14,
  },
  tableGridColumns: "12fr 17fr 18fr 11fr 14fr 14fr 14fr",
  tableMinWidth: 1100,
} as const
